
























































import { Component, Vue } from 'vue-property-decorator'
import ContentLayout from '@/apps/open/layout/ContentLayout.vue'
import Button from '@components/Button'
import { onRequestError } from '@/apps/open/utils'
import { OPEN_API } from '@/apps/open/constants'
import { checkAppCompanyAuthorizable, getSuperAdminInfo, getCompanyId } from '@/apps/open/services/app'
import { priSubPath } from '@/apps/open/constants/index'

const deployEnv = process.env.VUE_APP_DEPLOY_ENVIRONMENT

@Component({
  components: {
    ContentLayout,
    Button
  }
})
export default class Sync extends Vue {
  sync_info: any = { auth: '', companyId: '' }
  labelWidth: string = '140px'
  ADParamsSettings: any[] = [
    { label: 'AD域服务器地址', prop: 'ad_server_link', value: '' },
    { label: 'AD域服务器端口', prop: 'ad_server_port', value: '' },
    { label: 'AD域管理员用户名', prop: 'ad_admin_account', value: '' },
    { label: 'AD域管理员密码', prop: 'ad_admin_password', value: '' },
    { label: 'BaseDN', prop: 'ad_base', value: '' }
  ]
  organizationParamsSettings: any[] = [
    { label: 'LDAP筛选', prop: 'ora_filter', value: '' },
    { label: '组织架构字段', prop: 'ora_field', value: '' },
    { label: '组织架构描述', prop: 'ora_desc', value: '' },
    { label: '组织架构标识', prop: 'ora_flag', value: '' }
  ]
  userInfoSettings: any[] = [
    { label: 'LDAP筛选', prop: 'user_info_filter', value: '' },
    { label: '用户姓名字段', prop: 'user_info_name', value: '' },
    { label: '用户手机字段', prop: 'user_info_phone', value: '' },
    { label: '用户邮箱字段', prop: 'user_info_email', value: '' },
    { label: '用户唯一标识', prop: 'user_info_flag', value: '' }
  ]
  actionType: string = 'view'
  superAdminInfo: any = ''
  loading: boolean = true
  isAuthorized: boolean = false
  isCompanySuperAdmin: boolean = false

  get companyAuthDocUrl () {
    return this.isPrivate ? '#/docs/enterprise-inner-app/current-ability/enterprise-inner-oauth/api-list' : '/docs/enterprise-inner-app/authorize/api-list'
  }

  get isPrivate () {
    return this.$store.getters['isPrivate']
  }

  get appId () {
    return this.$route.params.id
  }

  get rules () {
    let rules:any = {}
    // this.ADParamsSettings.forEach(i => {
    //   rules[i.prop] = [{ required: true, message: `请输入${i.label}`, trigger: 'blur' }, { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }]
    // })
    // this.organizationParamsSettings.forEach(i => {
    //   rules[i.prop] = [{ required: true, message: `请输入${i.label}`, trigger: 'blur' }, { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }]
    // })
    // this.userInfoSettings.forEach(i => {
    //   rules[i.prop] = [{ required: true, message: `请输入${i.label}`, trigger: 'blur' }, { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }]
    // })
    return rules
  }

  jumpCompanyAuthDoc () {
    window.open(this.companyAuthDocUrl)
  }

  getAuth () {
    const { protocol, hostname, pathname } = window.location
    const scope = 'corp_address_book'
    const cb = encodeURIComponent(protocol + '//' + hostname + pathname)
    const userName = this.superAdminInfo.name
    let link = `${OPEN_API}view/company/authorize?app_id=${this.appId}&cb=${cb}&scope=${scope}`
    if (this.isPrivate) {
      const authAPiUrl = (deployEnv === 'ksa' ? '/openapi/view/company/authorize' : '/open/view/company/authorize')
      const priScope = (deployEnv === 'ksa' ? 'corp_address_book' : 'corp_contacts_mgr')
      link = `${location.origin}${priSubPath}${authAPiUrl}?app_id=${this.appId}&cb=${cb}&scope=${priScope}`
    }
    if (this.isCompanySuperAdmin) {
      window.location.href = link
    } else {
      const dialogBody = `
        <div class="auth_link_wrap">
          <div class="auth_title">为保障企业数据安全，请复制链接发给 ${userName} 进行企业授权</div>
          <div class="auth_link">
            <input value="${link}" />
          </div>
        </div>
      `
      this.$dialog.show({
        title: '企业授权',
        body: dialogBody,
        buttons: [
          { text: '复制链接', type: 'primary', isCopy: true, message: link }
        ]
      })
    }
  }

  async loadSyncConfigs () {
    await this.getCompanyId()
    await this.checkAppCompanyAuthorizable()
    await this.getSuperAdminInfo()
    this.loading = false
  }

  async getCompanyId () {
    const res = await getCompanyId(this.appId)
    this.sync_info.companyId = res.data.open_comp_id
  }

  async checkAppCompanyAuthorizable () {
    try {
      const authRes = await checkAppCompanyAuthorizable(this.appId, this.sync_info.companyId, this.isPrivate ? deployEnv === 'ksa' ? 'corp_address_book' : 'corp_contacts_mgr' : 'corp_address_book')
      this.isAuthorized = authRes.data.authorizable
      this.isCompanySuperAdmin = true
    } catch (error) {
      // onRequestError(error)
    }
  }

  async getSuperAdminInfo () {
    try {
      const adminRes = await getSuperAdminInfo(this.sync_info.companyId, this.appId)
      this.superAdminInfo = adminRes.data
    } catch (error) {
      onRequestError(error)
    }
  }

  async created () {
    await this.loadSyncConfigs()
  }
}
